
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.223 11.344a1.816 1.816 0 01-1.446 0l-8.77-4.062a.862.862 0 010-1.539l8.77-4.093a1.816 1.816 0 011.446 0l8.771 4.062a.862.862 0 010 1.54l-8.77 4.092zM21.502 12.036l-9.386 4.323a1.537 1.537 0 01-1.277 0l-9.34-4.323M21.502 17.038l-9.386 4.323a1.539 1.539 0 01-1.277 0l-9.34-4.323","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    